import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFormFieldLayout } from 'components/FormField';
import FormStack from 'components/FormStack';
import { TitleCardWithToggle } from 'components/TitleCard';
import { MarkAsDoneModeField, CustomDataField, AssetOwningTeamField, DownloadPermissionField, AssetLibraryField, OpenInNewWindowField, SubtitlesField, AlternativeTextField, ScormSettingsField } from 'components/FormFields';
import config from 'utils/config';
import { ASSET_WRITE, hasPrivilege } from 'utils/privileges';
function AdvancedSettingsCard(_ref) {
  var _webUrl$value, _markAsDoneMode;
  var isDistributed = _ref.isDistributed,
    fields = _ref.fields,
    content = _ref.content,
    assetContentType = _ref.assetContentType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasAssetPermissions = hasPrivilege(ASSET_WRITE);
  var externalRefId = fields.externalRefId,
    ownerTeamId = fields.ownerTeamId,
    parentId = fields.parentId,
    download = fields.download,
    openInIframe = fields.openInIframe,
    webUrl = fields.webUrl,
    subtitles = fields.subtitles,
    alternativeText = fields.alternativeText,
    scormSettings = fields.scormSettings;
  var markAsDoneMode;
  if ('markAsDoneMode' in fields) {
    markAsDoneMode = fields.markAsDoneMode;
  }
  var contentId = content === null || content === void 0 ? void 0 : content.id;
  var isUrlInsecure = assetContentType === 'web' ? !(webUrl !== null && webUrl !== void 0 && (_webUrl$value = webUrl.value) !== null && _webUrl$value !== void 0 && _webUrl$value.startsWith('https://')) : false;
  var downloadableTypes = ['audio', 'document', 'video', 'image', 'document'];
  var openInNewWindowTypes = ['web', 'scorm', 'zip'];
  return /*#__PURE__*/React.createElement(TitleCardWithToggle, {
    variant: "raised",
    title: t('menu_advanced_settings')
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, config.autoMarkAsDone && /*#__PURE__*/React.createElement(MarkAsDoneModeField, {
    isScormCourse: assetContentType === 'scorm',
    mode: (_markAsDoneMode = markAsDoneMode) === null || _markAsDoneMode === void 0 ? void 0 : _markAsDoneMode.value,
    onChange: function onChange(newMode) {
      var _markAsDoneMode2;
      return (_markAsDoneMode2 = markAsDoneMode) === null || _markAsDoneMode2 === void 0 ? void 0 : _markAsDoneMode2.set(newMode);
    }
  }), ownerTeamId && !isDistributed && config.managersCreateAssets && hasPrivilege(ASSET_WRITE) && /*#__PURE__*/React.createElement(AssetOwningTeamField, {
    values: [ownerTeamId.value],
    defaultOwnerTeamIds: [ownerTeamId.defaultValue],
    contentIds: contentId ? [contentId] : undefined,
    onChange: function onChange(ownerTeamIds) {
      return ownerTeamId.set(ownerTeamIds[0]);
    }
  }), parentId && hasAssetPermissions && !isDistributed && /*#__PURE__*/React.createElement(AssetLibraryField, {
    content: content,
    folderId: parentId.value,
    onChange: parentId.set
  }), download && downloadableTypes.includes(assetContentType) && /*#__PURE__*/React.createElement(DownloadPermissionField, {
    isDisabled: isDistributed,
    value: download.value,
    onChange: download.set
  }), externalRefId && config.enableContentExternalReference && hasPrivilege(ASSET_WRITE) && /*#__PURE__*/React.createElement(CustomDataField, {
    customData: externalRefId.value || '',
    onChange: function onChange(e) {
      return externalRefId === null || externalRefId === void 0 ? void 0 : externalRefId.set(e.target.value);
    }
  }), openInIframe && openInNewWindowTypes.includes(assetContentType) && /*#__PURE__*/React.createElement(OpenInNewWindowField, {
    isDisabled: isDistributed || isUrlInsecure,
    isUrlInsecure: isUrlInsecure,
    value: openInIframe.value,
    onChange: openInIframe.set
  }), alternativeText && assetContentType === 'image' && /*#__PURE__*/React.createElement(AlternativeTextField, {
    isDisabled: isDistributed,
    value: alternativeText.value,
    onChange: function onChange(e) {
      return alternativeText.set(e.target.value);
    }
  }), subtitles && assetContentType === 'video' && /*#__PURE__*/React.createElement(SubtitlesField, {
    isDisabled: isDistributed,
    assetId: contentId,
    subtitles: subtitles.value,
    onChange: subtitles.set
  }), scormSettings && assetContentType === 'scorm' && /*#__PURE__*/React.createElement(ScormSettingsField, {
    isDisabled: isDistributed,
    value: scormSettings.value,
    wasChanged: scormSettings.wasChanged,
    onChange: scormSettings.set
  }))));
}
export default AdvancedSettingsCard;